import styled from '@emotion/styled';

const Wrapper = styled.div`
  flex: 1;
  margin: auto;
`;

const Spacer: React.FC<any> = () => {
  return <Wrapper />;
};

export default Spacer;
